import { useEffect, useState } from "react";

export default function UserEditForm({ user, onSubmit, loading, error }) {
  const [branchIdx] = useState(String(user?.branch_idx ?? ""));
  const [branchName] = useState(user?.branch_name ?? "");
  const [idVal] = useState(user?.id ?? "");

  const [userName, setUserName] = useState(user?.user_name || "");
  const [phone, setPhone] = useState(user?.phone_number || "");
  const [email, setEmail] = useState(user?.email || "");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");

  useEffect(() => {
    setUserName(user?.user_name || "");
    setPhone(user?.phone_number || "");
    setEmail(user?.email || "");
  }, [user]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const lang = (typeof document !== "undefined" && document.documentElement?.lang) || "ko";

    // 원본(user_edit.js) 규칙: 둘 중 하나만 입력돼도 "일치 여부"만 검사
    if (password !== "" || passwordConfirm !== "") {
      if (password !== passwordConfirm) {
        alert(lang === "zh-CN" ? "两次输入的密码不一致。" : "비밀번호가 일치하지 않습니다.");
        return;
      }
    }

    onSubmit({
      branch_idx: branchIdx,
      id: idVal,
      user_name: userName,
      password, // 빈 문자열 전달도 허용(서버에서 무시)
      phone_number: phone,
      email,
    });
  };

  return (
    <div className="useredit">
      <form onSubmit={handleSubmit} className="usereditform">
        <div id="content_title"><h2>개인정보</h2></div>

        <p>지점</p>
        <select value={branchIdx} disabled className="none">
          <option value={branchIdx}>{branchName || "지점"}</option>
        </select>

        <p>아이디</p>
        <input value={idVal} disabled tabIndex={-1} aria-readonly="true" className="none"/>

        <p>이름</p>
        <input value={userName} onChange={(e)=>setUserName(e.target.value)} placeholder="이름" />

        <p>전화번호</p>
        <input value={phone} onChange={(e)=>setPhone(e.target.value)} placeholder="010-1234-5678" />

        <p>이메일</p>
        <input type="email" value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="이메일" />

        <p>새 비밀번호 (선택)</p>
        <input type="password" value={password} onChange={(e)=>setPassword(e.target.value)} placeholder="변경 시 입력" />

        <p>새 비밀번호 확인</p>
        <input type="password" value={passwordConfirm} onChange={(e)=>setPasswordConfirm(e.target.value)} placeholder="변경 시 입력" />

        <button disabled={loading} className="editsubmit">
          {loading ? "저장 중…" : "저장하기"}
        </button>
        {error && <p className="error">{error}</p>}
      </form>
    </div>
  );
}
